import React from 'react';
import { Toast } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import { useMilitaryVerificationSuccess } from '../../../contexts/MilitaryVerificationSuccessContext';
import { IDME_SUCCESS_MSG } from '../../../constants/alert-messages';

/* The design system offers 5s, 7s and 9s and nothing else. The shortest is what
/* a one-line confirmation with nothing to act on wants - and a customer who
/* would rather not wait it out has the close button. */
const AUTO_DISMISS_MS = 5000;

export const MilitaryVerificationSuccessToast = () => {
  const { isToastOpen, dismissToast } = useMilitaryVerificationSuccess();

  /* Also what keeps Toast off the server: it reads `document.body` for its
  /* default anchor while rendering, unguarded, so an SSR pass that reached one
  /* would throw - closed or not. Nothing can flip this flag before hydration,
  /* since the code exchange that reports success runs from an effect, so the
  /* server never gets past here. */
  if (!isToastOpen) {
    return null;
  }

  return (
    <Toast
      open
      decoration={<Checkmark />}
      duration={AUTO_DISMISS_MS}
      message={IDME_SUCCESS_MSG}
      /* Fires once the exit transition has finished, whichever way it was
      /* started - timeout, close button, Escape or swipe. Takes down the
      /* confirmation only: the verification it confirmed outlives it. */
      onClose={dismissToast}
      showCloseButton
    />
  );
};

MilitaryVerificationSuccessToast.displayName =
  'MilitaryVerificationSuccessToast';
